import React, { Component } from 'react'
import Dialog from '@mui/material/Dialog'
import styles from './MensagemTelaInicial.module.css'
import cookie from 'cookie-machine'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'

export const EXIBICAO_NOTIFICACAO_TELA_INICIAL = '__NOTIFICACAO_TELA_INICIAL__'
export class MensagemTelaInicial extends Component {
  constructor(props) {
    super(props)
    this.state = {
      popupAberto: false
    }
  }

  componentDidMount() {
    this.setState({ popupAberto: this.recuperaCookieExibicaoNotificacaoTelaInicial() })
  }

  recuperaCookieExibicaoNotificacaoTelaInicial() {
    // const seExibeNotificacao = cookie.get(EXIBICAO_NOTIFICACAO_TELA_INICIAL)
    // return (isAmbienteE2e()) ? false : seExibeNotificacao === undefined ? true : seExibeNotificacao === 'true'
    return false // alerta desabilitado
  }

  handleClose() {
    this.marcaNotificacaoComoLida()
    this.setState({ popupAberto: false })
  }

  marcaNotificacaoComoLida() {
    cookie.set(EXIBICAO_NOTIFICACAO_TELA_INICIAL, false)
  }

  renderConteudoMensagem() {
    return (
      <Grid>
        <Grid container spacing={1} alignItems='center' className={styles.gridMensagemHead}>
          <Grid item xs={2}>
            <img src='images/icone-dica.png' alt='Ícone da dica' />
          </Grid>
          <Grid item xs={8}>
            <Typography variant='subtitle2' color='primary' className={styles.tituloMensagem}>
              Entrou em produção o
            </Typography>
            <Typography
              variant='subtitle2'
              color='primary'
              className={styles.tituloMensagemDestaque}>
              Contexto Fiscalizações!
            </Typography>
          </Grid>
          <Grid item xs={1}>
            <IconButton className={styles.closeIcon} onClick={() => this.handleClose()}>
              <CloseIcon />
            </IconButton>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item sm={12} className={styles.corpoTexto}>
            <div className={styles.textoDestaque1}>Colega auditor (a)</div>
            <div className={styles.textoDestaque2}>
              O Contexto Fiscalizações está disponível para uso.
            </div>
            <div>
              O propósito da nova funcionalidade é promover, por meio das plataformas e-TCU
              (internamente) e Conecta-TCU (externamente), interação direta entre a equipe de
              fiscalização do TCU e gestores dos órgãos fiscalizados. Convém registrar que o
              Contexto Fiscalizações, ao seguir rígidos protocolos estabelecidos em normativos,
              garante a confidencialidade, a integralidade, a disponibilidade e o armazenamento dos
              documentos recebidos e dos gerados pela própria equipe de fiscalização.
            </div>
            <div>O Contexto de Fiscalização, por meio da plataforma e-TCU, permite:</div>
            <ol>
              <li>
                Troca direta de informações e demandas (ofícios de requisição e respectivas
                respostas) entre a equipe do Tribunal e os interlocutores designados para atuarem em
                cada fiscalização (pontos focais);
              </li>
              <li>
                Envio de ofícios de requisição para órgãos/entidades não presentes no FiscalisPlan
                pela própria equipe de fiscalização;
              </li>
              <li>
                Armazenamento e gestão de papéis de trabalho da fiscalização, incluindo aqueles
                criados pelas equipes de auditoria;
              </li>
              <li>Juntada dos papéis de trabalho diretamente no processo como peças.</li>
            </ol>
            <div>Seguem os links para acesso dos tutoriais para ambas as plataformas:</div>
            <div style={{ paddingTop: 12 }}>
              <span>
                e-TCU :{' '}
                <a
                  href='https://contas.tcu.gov.br/ords/registra_pesquisa_serv_adm/srv/anexo_servico_cidadao?COD=57'
                  target='_blank'
                  rel='noopener noreferrer'>
                  https://contas.tcu.gov.br/ords/registra_pesquisa_serv_adm/srv/anexo_servico_cidadao?COD=57
                </a>
              </span>
            </div>
            <div style={{ paddingTop: 12 }}>
              <span>
                Conecta-TCU:{' '}
                <a
                  href='https://contas.tcu.gov.br/ords/registra_pesquisa_serv_adm/srv/anexo_servico_cidadao?COD=56'
                  target='_blank'
                  rel='noopener noreferrer'>
                  https://contas.tcu.gov.br/ords/registra_pesquisa_serv_adm/srv/anexo_servico_cidadao?COD=56
                </a>
              </span>
            </div>
          </Grid>
        </Grid>
      </Grid>
    )
  }

  render() {
    return this.state.popupAberto === true ? (
      <Dialog open PaperProps={{ className: styles.operacoesMensagemPaper }}>
        <React.Fragment>{this.renderConteudoMensagem()}</React.Fragment>
      </Dialog>
    ) : (
      ''
    )
  }
}

export default MensagemTelaInicial
